import { Controller } from '@hotwired/stimulus';
import { fireChangeEvent } from '../search/accordion_change';

export default class CheckboxController extends Controller {
  static values = {
    label: String,
    serverChecked: Boolean,
  };

  connect() {
    fireChangeEvent(this.element, this._getDisplayText());
  }

  onChange() {
    fireChangeEvent(this.element, this._getDisplayText());
  }

  onFormReset(event) {
    if (!event.target.contains(this.element)) {
      return;
    }

    this.element.checked = this.serverCheckedValue;
    fireChangeEvent(this.element, this._getDisplayText());
  }

  _getDisplayText() {
    return this.element.checked ? this.labelValue || '' : '';
  }
}
